import Image from "common/components/Image";
import confirmCalendar from "common/images/confirm-calendar.svg";
import { pluralized } from "common/utils/strings";

import { useFeatures } from "client/clinics/hooks";
import PillButton from "client/common/components/buttons/PillButton";

import { ClientAppointmentWithForms } from "../types";

import styles from "../styles/AppointmentConfirm.module.less";

type AppointmentConfirmationSuccessProps = {
  appointments: ClientAppointmentWithForms[];
};

const AppointmentConfirmSuccess = ({ appointments }: AppointmentConfirmationSuccessProps) => {
  const features = useFeatures();
  const formRequests = features.FORMS ? appointments.flatMap((appt) => appt.form_requests) : [];
  const dashboardLink = formRequests.length > 0 ? formRequests[0].dashboard_link : null;

  return (
    <div className={styles.container}>
      <Image className={styles.image} src={confirmCalendar} alt="calendar" />
      <div className={styles.content}>
        <div className={styles.title}>
          Your {pluralized(appointments.length, "appointment is", "appointments are")} confirmed
        </div>
        <div className={styles.body}>
          {dashboardLink
            ? `See you soon! Please complete ${pluralized(formRequests.length, "this form", "these forms")} prior to your appointment:`
            : "See you soon!"}
        </div>
        {dashboardLink && (
          <div className={styles.forms}>
            <div className={styles.formLinks}>
              <PillButton href={dashboardLink} newTab={true} className={styles.formButton}>
                Complete {pluralized(formRequests.length, "form", "forms")}
              </PillButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppointmentConfirmSuccess;
